const serviciosFooterThemes = {
    default: {
        background: "linear-gradient(135deg, #17181b 0%, #2f3338 100%)",
    },
    "wellness-corporativo": {
        background: "linear-gradient(135deg, #161719 0%, #2a3a32 100%)",
    },
    "proyectos-tecnologicos": {
        background: "linear-gradient(135deg, #0f172a 0%, #183b66 100%)",
    },
    "marketing-publicidad": {
        background: "linear-gradient(135deg, #1e1a1f 0%, #4b2233 100%)",
    },
    "servicios-medicos": {
        background: "linear-gradient(135deg, #21181b 0%, #5b2228 100%)",
    },
    "produccion-eventos": {
        background: "linear-gradient(135deg, #13161b 0%, #0d4f63 100%)",
    },
    "capacitacion-laboral": {
        background: "linear-gradient(135deg, #1c1610 0%, #6e4512 100%)",
    },
};

export default serviciosFooterThemes;
